import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, isVisible } from '@fretadao/f-js-dom';
import { isBlank } from '@fretadao/f-js-utils';

/**
 * Used to manage routing request passenger form
**/
application.register('routing-request-address-form', class extends Controller {
  static values = { addressCardIdPrefix: String };

  static targets = [
    'streetField',
    'numberField',
    'referenceField',
    'cityField'
  ];

  connect() {
    this.#disableAutocomplete();
  }

  updateAddressCard() {
    const addressCard = this.#addressCard();
    const addressCardTitleLine = this.#addressCardTitleLine(addressCard);
    const addressCardStreetLine = this.#addressCardStreetLine(addressCard);
    const addressCardRegionLine = this.#addressCardRegionLine(addressCard);

    if(!this.#isAddressFilled()) {
      addressCardTitleLine.innerText = 'Endereço Padrão';
      addressCardStreetLine.innerText = 'Será usado o endereço da assinatura de cada funcionário.';
      addressCardRegionLine.innerText = '';
    } else {
      addressCardTitleLine.innerText = 'Endereço Personalizado';
      addressCardStreetLine.innerText = this.#streetLineText();
      addressCardRegionLine.innerText = this.#regionText();
    }

    this.#highlighCard(addressCard);
  }

  #addressCard() {
    return find(this.#addressCardId());
  }

  #addressCardTitleLine(addressCard) {
    return find(this.#addressCardTitleLineId(), addressCard);
  }

  #addressCardStreetLine(addressCard) {
    return find(this.#addressCardStreetLineId(), addressCard);
  }

  #addressCardRegionLine(addressCard) {
    return find(this.#addressCardRegionLineId(), addressCard);
  }

  #addressCardId() {
    return `#${this.addressCardIdPrefixValue}-address-card`;
  }

  #addressCardTitleLineId() {
    return `#${this.addressCardIdPrefixValue}-address-card-title`;
  }

  #addressCardStreetLineId() {
    return `#${this.addressCardIdPrefixValue}-address-card-street`;
  }

  #addressCardRegionLineId() {
    return `#${this.addressCardIdPrefixValue}-address-card-region`;
  }

  #streetLineText() {
    let streetLine = this.streetFieldTarget.value || '';
    const addressNumber = this.numberFieldTarget.value;
    const addressReference = this.referenceFieldTarget.value;

    if(!isBlank(addressNumber)) streetLine += `, ${addressNumber}`;
    if(!isBlank(addressReference)) streetLine += ` (${addressReference})`;

    return streetLine;
  }

  #regionText() {
    const cityField = this.cityFieldTarget;

    return cityField.options[cityField.options.selectedIndex].label
  }

  #isAddressFilled() {
    return !isBlank(this.streetFieldTarget.value);
  }

  #highlighCard(addressCard) {
    if (isVisible(addressCard)) addressCard.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 3000, delay: 500 });
  }

  #disableAutocomplete() {
    const disableAutocompleteSignal = this.#disableAutocompleteSignal();

    [this.streetFieldTarget, this.numberFieldTarget, this.referenceFieldTarget]
    .forEach(field => field.autocomplete = disableAutocompleteSignal);
  }

  // TODO: Transfer this to dom-js lib
  #disableAutocompleteSignal() {
    return this.#isGoggleChromeBrowser() ? 'disabled' : 'off'
  }

  // TODO: Transfer this to dom-js lib
  #isGoggleChromeBrowser() {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }
});
